import { API_CONSTANT } from "../../../utils/constant";
import { ServiceLogoProps } from "./serviceLogoModal.props";
import { Div } from "./serviceLogoModal.styled";

const ServiceLogoModal = ({ dataService,tab }: ServiceLogoProps) => {
  if (!dataService) return null;

  const apiDomain = process.env.REACT_APP_API_DOMAIN;
  const offerorLogoUrl = dataService?.commerceFirmData?.offerorLogoUrl || "";

  return (
    <Div className="container flex justify-center max-h-[180px]">
      <img
        className="w-full h-full max-h-[180px]"
        style={{ objectFit: "contain" }}
        src={`${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG}${encodeURIComponent(
          offerorLogoUrl.split('?')[0]
        )}`}
        alt={tab === "service" ? "Service Logo" : "Product Logo"}
      />
    </Div>
  );
};

export default ServiceLogoModal;
